import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Form } from 'core/components';
import { FormField } from 'core/components';
import { InputType } from 'core/enums';
import { FormProvider } from 'core/states';
import { useJobActions } from 'jobs/hooks';
import { IJobNameUpdateForm, IRenameJobData } from 'jobs/types';

import { updateJobNameSchema } from './schema';

interface IProps {
  jobId: number;
  projectId: number;
  isOpen: boolean;
  onClose?: () => void;
  onSubmitSuccess: (data: IJobNameUpdateForm) => void;
  defaultValues?: Partial<IRenameJobData>;
}

export const UpdateJobName = function ({
  isOpen = false,
  jobId,
  projectId,
  onClose,
  onSubmitSuccess,
  defaultValues,
}: IProps) {
  const { t } = useTranslation();

  const { updateJobName } = useJobActions();

  const onSubmit =
    (reset: UseFormReset<IJobNameUpdateForm>) => async (data: IJobNameUpdateForm) => {
      const { success } = await updateJobName({
        bom: {
          id: jobId,
          projectId: projectId,
          jobName: data.jobName,
        },
      });

      if (!success) {
        return;
      }

      setTimeout(() => {
        onSubmitSuccess(data);

        handleOnClose(reset);
      }, 1000);
    };

  const handleOnClose = (reset: UseFormReset<IJobNameUpdateForm>) => {
    reset();
    onClose();
  };

  return (
    <FormProvider schema={updateJobNameSchema()} defaultValues={defaultValues} resetDefaultValues>
      <Form
        title={t('titleUpdateJobDetails')}
        isOpen={isOpen}
        onClose={handleOnClose}
        onSubmit={onSubmit}
        submitBtnLabel={t('buttonLabelUpdateJobDetails')}
      >
        <FormField
          name="jobName"
          type={InputType.TEXT_INPUT}
          inputProps={{ label: t('labelJobName') }}
        />
      </Form>
    </FormProvider>
  );
};
